<template>
    <div class="bng-history-transactions">
        <!-- transactions -->
        <div class="table-container">
            <table class="table is-striped is-hoverable is-fullwidth is-size-7 bng-nowrap transactions">
                <thead>
                    <tr>
                        <th>{{ "components.pages.history.transactions.time" | translate }}</th>
                        <th>{{ "components.pages.history.transactions.number" | translate }}</th>
                        <th></th>
                        <th>{{ "components.pages.history.transactions.action" | translate }}</th>
                        <th>{{ "components.pages.history.transactions.amount" | translate }}</th>
                        <th>{{ "components.pages.history.transactions.balance" | translate }}</th>
                        <th
                            v-if="anyBonuses"
                        >{{ "components.pages.history.transactions.bonus" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="transaction in transactions">
                        <tr
                            :class="{ 'merchant': transaction.source === 'MerchantService' }"
                            @click="transaction.showDetails = !transaction.showDetails"
                            :key="transaction.id"
                        >
                            <td>
                                <template v-if="transaction.source === 'MerchantService'">
                                    <template v-if="transaction.showDetails">
                                        <span class="icon is-small">
                                            <i class="fas fa-angle-down" aria-hidden="true"></i>
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="icon is-small">
                                            <i class="fas fa-angle-right" aria-hidden="true"></i>
                                        </span>
                                    </template>
                                </template>
                                {{ transaction.date | localDatetime("") }}
                            </td>
                            <th>{{ transaction.number }}</th>
                            <td>
                                <template v-if="transaction.games && transaction.games.length">
                                    <div
                                        v-for="(game, i) in transaction.games"
                                        class=""
                                        :key="i"
                                    >
                                        <template v-if="game.gameName">{{game.gameName}}</template>
                                        <template
                                            v-else
                                        >{{`games.${game.provider}.${game.gameId}` | translate}}</template>
                                    </div>
                                </template>
                                <div
                                    v-if="transaction.pinInfo"
                                    class=""
                                >{{ "components.pages.history.transactions.pin" | translate }} {{transaction.pinInfo.pin}}</div>
                                <div
                                    v-if="anyBonuses && transaction.bonusInfo"
                                    class="has-text-danger"
                                >
                                    <template
                                        v-if="transaction.amount && transaction.type=='Deposit'"
                                    >{{ `bonus.${transaction.bonusInfo.bonusType}.transferred` | translate }}</template>
                                    <template
                                        v-else
                                    >{{ `bonus.${transaction.bonusInfo.bonusType}.title` | translate }}</template>
                                </div>
                                <div
                                    v-if="transaction.source === 'MerchantService'"
                                    class=""
                                >{{ "components.pages.history.merchant.short desc" | translate }}</div>
                            </td>
                            <td>
                                <span
                                    v-if="transaction.source === 'MerchantService'"
                                >{{ `components.pages.history.merchant.type.${transaction.type}` | translate }}</span>
                                <template v-else-if="gameCategory && gameCategory != 'poker'">
                                    <span
                                        v-if="transaction.type=='Withdraw'"
                                        class=""
                                    >{{ "components.pages.history.transactions.bet" | translate }}</span>
                                    <span
                                        v-if="transaction.type=='Deposit'"
                                        class="has-text-success"
                                    >{{ "components.pages.history.transactions.win" | translate }}</span>
                                    <span
                                        v-if="transaction.type=='Zero'"
                                        class=""
                                    >{{ "components.pages.history.transactions.loss" | translate }}</span>
                                </template>
                                <template v-else-if="transaction.jackpotInfo">
                                    <span
                                        v-if="transaction.type=='Deposit'"
                                        class="has-text-error"
                                    >{{ $t("history.jackpot win", {'jackpot': transaction.jackpotInfo.jackpotName }) }}</span>
                                </template>
                                <template v-else>
                                    <span
                                        v-if="transaction.type=='Deposit'"
                                        class="has-text-success"
                                    >{{ "components.pages.history.transactions.deposit" | translate }}</span>
                                    <span
                                        v-if="transaction.type=='Withdraw'"
                                        class=""
                                    >{{ "components.pages.history.transactions.withdraw" | translate }}</span>
                                </template>
                            </td>
                            <td>
                                <template v-if="transaction.amount">
                                    <span
                                        v-if="transaction.source === 'MerchantService'"
                                    >{{ transaction.amount | currency(transaction.currency) }}</span>
                                    <template v-else>
                                        <span
                                            v-if="transaction.type=='Deposit'"
                                            class="has-text-success"
                                        >+{{ transaction.amount | currency(transaction.currency) }}</span>
                                        <span
                                            v-if="transaction.type=='Withdraw'"
                                            class=""
                                        >{{ transaction.amount | currency(transaction.currency) }}</span>

                                        <template v-if="transaction.taxes">
                                            <span
                                                class="has-text-grey-light">
                                                <span
                                                    v-for="(tax, index) in transaction.taxes"
                                                    :key="`tax-${transaction.id}-${index}`"
                                                    >
                                                    ({{ tax.type }}Tax {{ Math.abs(tax.factor * 100) }}%: {{ Math.abs(tax.value) | currency(transaction.currency) }})
                                                </span>
                                            </span>
                                        </template>
                                        <template v-else>
                                            
                                        </template>
                                    </template>
                                </template>
                                <template v-if="anyBonuses && transaction.bonus">
                                    <span
                                        v-if="transaction.type=='Deposit'"
                                        class="has-text-success has-text-weight-bold"
                                    >+{{ transaction.bonus | currency(transaction.currency) }} {{"components.pages.history.transactions.bonus" | translate}}</span>
                                    <span
                                        v-if="transaction.type=='Withdraw'"
                                        class=""
                                    >{{ transaction.bonus | currency(transaction.currency) }} {{"components.pages.history.transactions.bonus" | translate}}</span>
                                </template>
                            </td>
                            <td>{{ transaction.balanceAfter | currency(transaction.currency) }}</td>
                            <td
                                v-if="anyBonuses"
                            >{{ transaction.bonusAfter | currency(transaction.currency) }}</td>
                        </tr>
                        <tr
                            v-if="transaction.showDetails && transaction.source === 'MerchantService'"
                            :key="`merchant-details-${transaction.id}`"
                        >
                            <td colspan="9">
                                <merchant-operation :transaction="transaction" />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- load more -->
        <div class="field">
            <a
                v-if="hasLoadMore"
                :class="[{ 'is-loading': loading }, 'button', 'is-info', 'is-large']"
                @click="loadMore();"
            >{{ "components.pages.history.load more" | translate }}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import transactionService from '../../../../../../_common/services/transaction.service';
import balanceService from '../../../../../../_common/services/balance.service';
import utils from '../../../../../../_common/utils';

import Description from '../../../common/description/description.vue';
import MerchantOperation from './merchant-operation';

export default {
    name: 'history-transactions',
    components: { Description, MerchantOperation },
    props: {
        filterDepositWithdraw: {
            type: Boolean,
            default: false
        },
        filterBonus: {
            type: Boolean,
            default: false
        },
        gameCategory: {
            validator: prop => typeof prop === 'string' || prop === null,
            default: null
        }
    },
    data: () => ({
        transactions: [],
        take: 20,
        skip: 0,
        loading: false,
        hasLoadMore: true
    }),
    computed: {
        client() {
            return Vue.state.client.get();
        },
        anyBonuses() {
            return this.client && this.client.bonus.anyBonuses;
        },
        balance: function() {
            return Vue.state.history.balance.get();
        },
        date: function() {
            return Vue.state.history.date.get();
        }
    },
    watch: {
        $route(to, from) {
            this.refresh();
        },
        balance: async function() {
            await this.refresh();
        },
        date: async function() {
            await this.refresh();
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async loadMore() {
            this.skip += this.take;
            let loadedTransactions = await this.getTransactions();
            this.transactions.push(...loadedTransactions);
            this.hasLoadMore = loadedTransactions.length >= this.take;
        },
        async refresh() {
            this.skip = 0;
            let loadedTransactions = await this.getTransactions();
            this.transactions.splice(0, this.transactions.length);
            this.transactions.push(...loadedTransactions);
            this.hasLoadMore = loadedTransactions.length >= this.take;
        },
        async getTransactions() {
            let transactions = await transactionService.getTransactions(
                this.balance.id,
                this.date,
                this.take,
                this.skip,
                this.filterDepositWithdraw,
                this.filterBonus,
                this.gameCategory
            );
            for (let i = 0; i < transactions.length; i++) {
                transactions[i].showDetails = false;
            }
            return transactions;
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/transactions.vue